export const getNextPopup = (state) => {
  return state.popupStack[0];
};
